var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 82,
    viewBox: "0 0 90 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9498 12.5764L46.0372 -0.141846L43.0187 7.90047L55.1917 12.4691H10.1753C5.4392 12.4691 1.58765 16.3206 1.58765 21.0567V72.5825C1.58765 77.3186 5.4392 81.1702 10.1753 81.1702H78.8763C83.6124 81.1702 87.464 77.3186 87.464 72.5825V21.0567C87.464 16.6856 84.1706 13.1132 79.9498 12.5764ZM10.1753 72.5825V42.5258H78.8763V33.9382H10.1753V21.0567H78.8763L78.8806 72.5825H10.1753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8481 68.2887C69.7766 68.2887 74.5826 63.4827 74.5826 57.5541C74.5826 51.6256 69.7766 46.8196 63.8481 46.8196C57.9195 46.8196 53.1135 51.6256 53.1135 57.5541C53.1135 63.4827 57.9195 68.2887 63.8481 68.2887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7629 55.4072H40.2277V63.9949H18.7629V55.4072Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.0516,
    height: 82,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadio);
export default __webpack_public_path__ + "static/media/radio.de6cf99009f2ab98505b3e57ff24d3ec.svg";
export { ForwardRef as ReactComponent };